// extracted by mini-css-extract-plugin
export default {"back-to-top-btn":"BackToTopButton_back-to-top-btn__iQEbF"};